import { useEffect, useState } from "react";
import { apiFetch } from "../services/api";
import FormCliente from "../components/FormClient";
import TabelaClientes from "../components/TabelaClient";

export default function Home() {
  const [clientes, setClientes] = useState([]);

  async function carregar() {
    try {
      const res = await apiFetch("clientes");
      setClientes(res.clientes || []);
    } catch (err) {
      console.error("Erro ao carregar clientes:", err);
    }
  }

  useEffect(() => {
    carregar();
  }, []);

  return (
    <div>
      <div className="container">
        <h2>Gerenciador de Clientes</h2>
        <FormCliente onSuccess={carregar} />
      </div>

      <div className="container">
        <TabelaClientes clientes={clientes} />
      </div>
    </div>
  );
}
